import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { isAddress } from 'viem'

/// Resolves which address the Portfolio is viewing: the connected wallet by default, or an explicit
/// `?view=0x...` URL param that deep-links into a READ-ONLY view of that address (a Leaderboard row
/// links to exactly this, and any shared link works too). No signer, no contract, no local state -
/// pure view resolution.
///
/// The manual "watch / add address" list was removed (founder call): viewing another address is
/// deep-link only now, so there is no localStorage list and no in-app add/remove.
export function useViewedAddress(connected) {
  const [searchParams] = useSearchParams()
  const urlView = searchParams.get('view')

  const viewAddress = useMemo(() => {
    if (urlView && isAddress(urlView)) return urlView
    return connected
  }, [urlView, connected])

  return {
    viewAddress,
    // Requires a CONNECTED wallet to compare against, so it is false for a logged-out visitor who
    // opens someone else's shared `?view=` link - they simply see that address, with nothing of
    // their own to contrast it against.
    isViewingOther: !!connected && !!viewAddress && viewAddress.toLowerCase() !== connected.toLowerCase(),
  }
}
